export default __webpack_public_path__ + "static/media/search-icon.ccfc8e25.svg";